import { hasValue } from "../../../utils/functions.js";
export default {
  name: "transaction-charge",
  data: function () {
    return {
      countFilter: 0,

      loading: false,
      loadingReport: false,
      loadingTransaction: false,

      mCurrentStep: 0,

      isSeeing: false,

      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: this.FilterDefault(),
      relatedTransactions: this.relatedTransactions,
      infoTransaction: {
        PaymentMethod: {
          Code: null,
        },
        Merchant: {
          Name: null,
          Documents: null,
        },
        Gateway: {
          Code: null,
          Id: null,
          Name: null,
        },
      },
      PaymentMethod: {
        Code: null,
        BankSlipNumber: null,
        DueDate: null,
        InstallmentQuantity: null,
      },

      PaymentObject: {
        Symbol: null,
        Brand: {
          Code: null,
        },
        Amount: null,
        Address: null,
        Provider: null,
        AdditionPayment: null,
        DiscountPayment: null,
        QrCode: null,
        BankData: {
          BankAgency: null,
          BankAgencyDigit: null,
          BankAccount: null,
          BankAccountDigit: null,
          Bank: {
            Name: null,
          },
        },
      },

      mSteps: [
        "Cliente",
        "Pagamento",
        "Produto",
        "Histórico de Status",
        "Splits",
        "Informações Adicionais",
        "Dados do Merchant",
        "Correlações"
      ],
      transactions: [],
      codeTransaction: "Código",
      labelNameCustomer: "Cliente",
      labelEmailCustomer: "E-mail do Cliente",
      labelIdentityCustomer: "CPF/CNPJ do Cliente",
      labelTransaction: "Id Transaction",
      labelReference: "Referência",
      labelApplication: "Aplicação",
      labelPayment: "Pagamento",
      labelTransactionStatus: "Status",
      labelAmount: "Valor",
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListTransactionCharge();
    },
    "pagination.RowsPerPage": function () {
      this.ListTransactionCharge();
    },
  },
  mounted() {
    this.GetClass();
  },
  methods: {
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListTransactionCharge();
    },
    ListTransactionCharge: function () {
      this.countFilter = 0;

      Object.values(this.filter).map(value => { if (hasValue(value)) this.countFilter++ });
      this.loading = true;

      let params = {
        "Object.Id": parseInt(this.filter.IdTransaction, 10) || null,
        "Object.Reference": this.filter.Reference,
        "Object.Customer.Identity": this.filter.IdentityCustomer,
        "Object.Customer.Name": this.filter.NameCustomer,
        "Object.Customer.Email": this.filter.EmailCustomer,
        "EndToEndId": this.filter.EndToEnd,
        ...this.pagination,
      };
      delete params.TotalItems;

      if (this.countFilter > 0) {
        this.$store
          .dispatch("ListTransactionCharge", { params: params })
          .then((response) => {
            this.transactions = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          })
          .catch((error) => {
            this.$makeToast(undefined, "danger", "Erro ao listar as cobranças", error);
          })
          .finally(() => (this.loading = false));
      } else {
        this.transactions = [];
        this.loading = false;
      }
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = this.FilterDefault();
      this.ListTransactionCharge();
    },
    FilterDefault(){
      return {
        IdTransaction: null,
        IdentityCustomer: null,
        NameCustomer: null,
        EmailCustomer: null,
        Reference: null,
        EndToEnd: null
      };
    },
    HideModal: function () {
      this.$bvModal.hide("mFormTransaction");
    },
    GetTransaction(transaction) {
      this.loadingTransaction = true;
      this.$store
        .dispatch("GetTransaction", { id: transaction.Id, idMerchant: transaction.Merchant.Id })
        .then((response) => {
          this.infoTransaction = response;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.loadingTransaction = false;
        });
    },
    ListCreditCardRefused() {
      const todayDate = new Date().toISOString().slice(0, 10);
      const lastMonth = new Date(todayDate);
      lastMonth.setMonth(lastMonth.getMonth() -1);
      this.loadingTransactionRelated = true;
      this.$store
        .dispatch("ListCreditCardRefused", { "Object.Customer.Identity": this.infoTransaction.Customer.Identity, "CreatedDateInitial": lastMonth })
        .then(response => {
          this.relatedTransactions = response.Objects;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro ao listar as transações relacionadas", error))
        .finally(() => {
          this.loadingTransactionRelated = false;
        });
    },
    OpenModalTransaction: function (i) {
      this.mCurrentStep = 0;
      //this.ResetinfoTransaction();

      // View
      this.pOpened = i;
      this.idTransaction = this.transactions[i].Id;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetTransaction(this.transactions[i]);
      this.$bvModal.show("mFormTransaction");
    },
    GetClass: function () {
      if (this.infoTransaction != null && this.infoTransaction.Id > 0) {
        switch (this.infoTransaction.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
          case "19":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
            return " labelModal labeldanger";
        }
      }
    },
    BackStep: function () {
      if (this.mCurrentStep >= 1) {
        this.mCurrentStep -= 1;
      }
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    ProcessNextStep: function (nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
    },
    NextStep: function () {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        this.mCurrentStep += 1;
      }
    },
    Download(url) {
      if (url != null && url.length > 5) window.open(url, "_blank");
      else {
        this.$makeToast("O link do arquivo é inválido.", "danger", "Erro no download");
      }
    },
    ComputeExpirationPix(CreatedDate, Expiration){
      const expirationDate = new Date(CreatedDate);

      expirationDate.setSeconds(expirationDate.getSeconds() + Expiration);

      return expirationDate;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/TransactionCharge/TransactionCharge.js